/**
 * NOTE: Name with `Icon` word
 */
import downloadIcon from './download.svg';
import download2Icon from './download_2.svg';
import bundleIcon from './bundle.svg';
import videoIcon from './video.svg';
import calcIcon from './calculator.svg';
import copyIcon from './copy.svg';
import chartIcon from './chart.svg';
import docIcon from './doc.svg';
import sortDescendingIcon from './sort-desc.svg';
import cameraIcon from './camera.svg';
import refreshIcon from './refresh-icon.svg';
import envelopeIcon from './envelope.svg';
import editIcon from './edit.svg';
import docOutlineIcon from './doc_outline.svg';
import kickoutIcon from './kickout.svg';
import searchIcon from './search.svg';
import triangleIcon from './triangle.svg';
import calendarIcon from './calendar.svg';
import hamburgerIcon from './hamburger.svg';

// dealer success program
import digitalMedia from './digital-media.svg';
import traditionalPrint from './traditional-print.svg';
import physical from './physical.svg';

//notification icons
import infoIcon from './info-icon.svg';
import closeIcon from './closeIcon.svg';

// arrow icons > images likely change
import arrowleftIcon from './arrowleft.png';
import arrowrightIcon from './arrowright.png';
// used to be in recent annoucement link
import arrowRightCircleIcon from './arrow-right-circle.svg';

export {
  downloadIcon,
  download2Icon,
  bundleIcon,
  videoIcon,
  calcIcon,
  copyIcon,
  chartIcon,
  docIcon,
  sortDescendingIcon,
  cameraIcon,
  refreshIcon,
  envelopeIcon,
  editIcon,
  docOutlineIcon,
  kickoutIcon,
  searchIcon,
  triangleIcon,
  calendarIcon,
  infoIcon,
  closeIcon,
  arrowleftIcon,
  arrowrightIcon,
  arrowRightCircleIcon,
  digitalMedia,
  traditionalPrint,
  physical,
  hamburgerIcon
};



// WEBPACK FOOTER //
// ./src/images/icons/index.js